module.exports = __webpack_public_path__ + "img/页宽+居中页码.9c56e31e.jpg";